import { breakpointAtLeast } from './utils.js';

(function ($) {
  var mapStyles = [
    {
      featureType: 'all',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#000000',
        },
        {
          weight: '1.05',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          weight: '1.02',
        },
      ],
    },
    {
      featureType: 'administrative.province',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
        {
          hue: '#ff0000',
        },
        {
          saturation: '-100',
        },
        {
          lightness: '27',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'all',
      stylers: [
        {
          saturation: '-100',
        },
        {
          lightness: '68',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.stroke',
      stylers: [
        {
          weight: '0.01',
        },
        {
          saturation: '100',
        },
        {
          lightness: '-21',
        },
        {
          color: '#fccc9e',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [
        {
          visibility: 'simplified',
        },
        {
          saturation: '-100',
        },
        {
          lightness: '57',
        },
        {
          gamma: '2.51',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text',
      stylers: [
        {
          saturation: '-100',
        },
        {
          lightness: '-32',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [
        {
          saturation: -100,
        },
        {
          lightness: 45,
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#f7f6f5',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#facaa3',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'all',
      stylers: [
        {
          visibility: 'simplified',
        },
        {
          saturation: '-100',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffc59b',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#ffb363',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
        {
          saturation: '-100',
        },
        {
          lightness: '33',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffbe71',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#ffdbb6',
        },
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
        {
          saturation: '-100',
        },
        {
          lightness: '40',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#fbe9d4',
        },
        {
          saturation: '-8',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#ffe7d5',
        },
        {
          weight: '0.84',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          visibility: 'simplified',
        },
        {
          saturation: '-100',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          color: '#d7e9f9',
        },
        {
          visibility: 'on',
        },
      ],
    },
  ];

  // Save Markers by location
  var placeMarkerList = {};

  /*
   *  This function will render a Google Map onto the selected jQuery element
   */
  function new_map($el) {
    var mapOptions = {
      zoom: 14,
      panControl: false,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: true,
      overviewMapControl: false,
      scrollwheel: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: mapStyles,
    };

    var map = new google.maps.Map($el[0], mapOptions);

    map.markers = [];

    var $markers = $el.siblings('.js-marker');

    $markers.each(function () {
      add_marker($(this), map);
    });

    // Add a marker clusterer to manage the markers, but not on project map
    // Parse every country to display a cluster for the country
    for (var country in placeMarkerList) {
      if (placeMarkerList.hasOwnProperty(country)) {
        var markerCluster = new MarkerClusterer(map, placeMarkerList[country], {
          styles: [
            {
              url: GLOBAL.theme_dir + '/resources/images/markers/circle.svg',
              height: 45,
              width: 45,
              className: 'custom-clustericon',
            },
          ],
          maxZoom: 18,
        });
      }
    }

    // Set default bounds zoom 1 level lesser
    google.maps.event.addListenerOnce(map, 'bounds_changed', function (event) {
      var zoom = this.getZoom();
      // Set initial zoom to show bigger part of the city
      // Useful when we are showing just one marker
      if (zoom > 13) {
        this.setZoom(13);
      }

      // Slightly lower initial zoom in some cases (e.g. to show whole continent)
      if (zoom > 5 && zoom <= 13) {
        this.setZoom(this.getZoom() - 1);
      }
    });

    center_map(map);

    return map;
  }

  /**
   * Get marker data from HTML and it to google map object
   *
   * @param {jQuery object} $marker
   * @param {google map} map
   */
  function add_marker($marker, map) {
    var country = $marker.attr('data-country');
    var latlng = new google.maps.LatLng(
      $marker.attr('data-lat'),
      $marker.attr('data-lng'),
    );

    // create marker
    var marker = new google.maps.Marker({
      position: latlng,
      map: map,
      animation: google.maps.Animation.DROP,
      icon: GLOBAL.theme_dir + '/resources/images/markers/marker.png',
      title: '',
    });

    // Apply country grouping if country attribute is available
    if (country) {
      if (!placeMarkerList.hasOwnProperty(country)) {
        placeMarkerList[country] = [];
      }

      // Save marker in place marker list
      placeMarkerList[country].push(marker);
    } else {
      // add to array
      map.markers.push(marker);
    }

    var content = $marker.html();

    if (content) {
      // create info window
      var infowindow = new google.maps.InfoWindow({
        content: content,
      });

      // show info window when marker is clicked
      google.maps.event.addListener(marker, 'click', function () {
        infowindow.open(map, marker);
      });
    }
  }

  /**
   * Center map to boundaries created by map markers.
   *
   * @param {google map} map
   */
  function center_map(map) {
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    if (map.markers.length > 0) {
      $.each(map.markers, function (i, marker) {
        var latlng = new google.maps.LatLng(
          marker.position.lat(),
          marker.position.lng(),
        );
        bounds.extend(latlng);
      });
    }

    // loop through all markers grouped by country
    for (var country in placeMarkerList) {
      if (placeMarkerList.hasOwnProperty(country)) {
        // loop through all markers and create bounds
        $.each(placeMarkerList[country], function (i, marker) {
          var latlng = new google.maps.LatLng(
            marker.position.lat(),
            marker.position.lng(),
          );
          bounds.extend(latlng);
        });
      }
    }

    // center map to bounds
    map.fitBounds(bounds);
  }

  // Initialize maps
  if (typeof google !== 'undefined') {
    /*
     *  This function will render map when the document is ready (page has loaded)
     */
    $(document).ready(function () {
      var $googleMap = $('.js-google-map-onclick');
      var $showMap = $('.js-show-map');

      // Map is already initialized
      if ($googleMap.hasClass('map-loaded')) {
        return;
      }

      // Check if map should initialize on load (map tab is active by default)
      if ($showMap.hasClass('is-active')) {
        init_map($googleMap);
        return;
      }

      // Or initialize map after button is clicked
      $showMap.on('click', function () {
        init_map($googleMap);
      });
    });
  }

  function init_map($googleMap) {
    var map = new_map($googleMap);

    $googleMap.addClass('map-loaded');

    // Listen for bounds changes and show/hide projects which are/aren't within these bounds
    // Do this only on medium screens up
    if (breakpointAtLeast('medium')) {
      map.addListener('bounds_changed', function (e) {
        var bounds = map.getBounds();

        $('.js-map-project-item').each(function () {
          var $this = $(this);

          if ($this.data('lat') && $this.data('lng')) {
            var itemLatLng = new google.maps.LatLng({
              lat: +$this.data('lat'),
              lng: +$this.data('lng'),
            });

            if (bounds.contains(itemLatLng)) {
              $this.removeClass('is-hidden');
            } else {
              $this.addClass('is-hidden');
            }
          }
        });
      });
    }
  }
})(jQuery);
